import { formatDistanceToNowStrict, parseISO } from 'date-fns'

export const formatDateTime = (value?: string) => {
  if (!value) {
    return '—'
  }

  try {
    return new Date(value).toLocaleString()
  } catch {
    return value
  }
}

export const formatRelativeTime = (value?: string) => {
  if (!value) {
    return '—'
  }

  try {
    return formatDistanceToNowStrict(parseISO(value), { addSuffix: true })
  } catch {
    return value
  }
}

export const formatDurationSeconds = (seconds?: number, fallback = '—') => {
  if (seconds === undefined || Number.isNaN(seconds)) {
    return fallback
  }

  if (seconds < 60) {
    return `${Math.round(seconds)}s`
  }

  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = Math.round(seconds % 60)
    return `${minutes}m ${remainingSeconds}s`
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.round((seconds % 3600) / 60)
  return `${hours}h ${minutes}m`
}

export const formatPercentage = (value?: number, fallback = '0%') => {
  if (value === undefined || Number.isNaN(value)) {
    return fallback
  }

  return `${(value * 100).toFixed(1)}%`
}

export const formatNumber = (value?: number, fallback = '0') => {
  if (value === undefined || Number.isNaN(value)) {
    return fallback
  }

  return Intl.NumberFormat().format(value)
}
